import { Trans } from '@/plugins/Translation'

function load (component) {
  // '@' is aliased to src/components
  return () => import(/* webpackChunkName: "[request]" */ `@/pages/${component}.vue`)
}

export default [
  {
    path: '/:lang',
    component: {
      template: '<router-view></router-view>'
    },
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: '',
        name: 'home',
        component: load('Home'),
        meta: { bodyClass: 'home' }
      },
      {
        path: 'fighters',
        name: 'fighters',
        component: load('Fighters'),
        meta: { bodyClass: 'fighters' }
      },
      {
        path: 'fighters/:slug',
        name: 'fighters_view',
        component: load('FightersView'),
        display: false,
        meta: { bodyClass: 'fighters' },
        props: true
      },
      {
        path: 'media',
        name: 'media',
        component: load('Media'),
        meta: { bodyClass: 'media' }
      },
      {
        path: 'news',
        name: 'news',
        component: load('News'),
        meta: { bodyClass: 'news' },
        props: true
      },
      {
        path: 'news/:slug',
        name: 'news_view',
        component: load('NewsView'),
        display: false,
        meta: { bodyClass: 'news-view' },
        props: true
      },
      {
        path: 'signup',
        name: 'join_the_alpha',
        component: load('JoinCommunity'),
        display: false,
        meta: { bodyClass: 'signup' }
      },
      // {
      //   path: 'join-the-community',
      //   name: 'join_the_community',
      //   component: load('JoinCommunity'),
      //   display: false,
      //   meta: { bodyClass: 'join-community' }
      // },
      {
        path: 'redeem-code',
        name: 'redeem_code',
        component: load('RedeemCode'),
        display: false,
        meta: { bodyClass: 'signup' }
      },

      {
        path: 'dmca-policy',
        name: 'dmca_policy',
        component: load('DMCAPolicy'),
        display: false,
        meta: { bodyClass: 'dmca_policy' }
      },
      {
        path: 'contact',
        name: 'contact',
        component: load('Contact'),
        display: false,
        meta: { bodyClass: 'contact' }
      },
      {
        path: '*',
        name: 'error',
        component: load('404'),
        display: false,
      }
    ]
  },
  {
    // Redirect user to supported lang version.
    path: '*',
    redirect (to) {
      return Trans.getUserSupportedLang()
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js